import { UISref } from "@uirouter/react";
import React from "react";
import i18n from "i18next";

import { Icon } from "../../Common/Icon";

const ManageNotificationCard = () => {
  return (
    <div className="notification-card --end" key="link">
      <UISref to="manage-notifications">
        <span className="notification-card__link">
          <Icon className="notification-card__link --icon" id="send" />
          {i18n.t("notification.manage")}
        </span>
      </UISref>
    </div>
  );
};

export default ManageNotificationCard;



// WEBPACK FOOTER //
// ./src/components/Layout/Notifications/ManageNotificationCard.js